import { GraphType } from "../model/generic-graph";
import { sbuICLMock } from "./iclSBU.mock";
import { commoditiesSpecialtiesMock } from "./commoditiesICL.mock";
import { potashPrices } from "./potashPrices.mock";
import { productionKmtMock } from "./production-kmt.mock";
import { topTenCustomersMock } from "./topTenCustomers.mock";
import { financialKpiGraphMock } from "./financial-kpi.mock";
import { potashAvgPriceMock } from "./potashAvgPrice.mock";
import { ICLFcfGraphMock } from "./iclFcf.mock";
import { FcfGraphMock } from "./fcf.mock";
import { capexMock } from "./capex.mock";
import { updatedTopTenProductsMock } from "./iclTopTenProducts.mock";

const salesICLMock = {
  "type": "Sales",
  "title": "Sales",
  "subMenu": [
    {
      "data": [],
      "title": "Total",
      "subTitle": ""
    },
    {
      "data": [],
      "title": "IL",
      "subTitle": ""
    },
    {
      "data": [],
      "title": "IBP",
      "subTitle": ""
    },
    {
      "data": [],
      "title": "DSM",
      "subTitle": ""
    },
    {
      "data": [],
      "title": "OTH",
      "subTitle": ""
    }
  ],
  "navigation": {
    "nav": {
      "qtd": [
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 795,
                        "percent": null
                      },
                      "current": {
                        "value": 601,
                        "percent": -24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 951,
                        "percent": null
                      },
                      "current": {
                        "value": 580,
                        "percent": -39
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 854,
                        "percent": null
                      },
                      "current": {
                        "value": 160,
                        "percent": -36
                      },
                      "partial": {
                        "value": 252,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 713,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          474,
                          723
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -63,
                        "columns": [
                          68,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          55,
                          62
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 610,
                        "percent": null
                      },
                      "current": {
                        "value": 425,
                        "percent": -30
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 723,
                        "percent": null
                      },
                      "current": {
                        "value": 474,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 684,
                        "percent": null
                      },
                      "current": {
                        "value": 122,
                        "percent": -43
                      },
                      "partial": {
                        "value": 213,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 508,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          474,
                          723
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -63,
                        "columns": [
                          68,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          55,
                          62
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 137,
                        "percent": null
                      },
                      "current": {
                        "value": 137,
                        "percent": 0
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 185,
                        "percent": null
                      },
                      "current": {
                        "value": 68,
                        "percent": -63
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 113,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -6
                      },
                      "partial": {
                        "value": 20,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 149,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          474,
                          723
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -63,
                        "columns": [
                          68,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          55,
                          62
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 67,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -18
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 62,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -12
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 82,
                        "percent": null
                      },
                      "current": {
                        "value": 26,
                        "percent": -11
                      },
                      "partial": {
                        "value": 29,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 79,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          474,
                          723
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -63,
                        "columns": [
                          68,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          55,
                          62
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": -19,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": 12
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": -19,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": 14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": -25,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": 43
                      },
                      "partial": {
                        "value": -10,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": -24,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          474,
                          723
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -63,
                        "columns": [
                          68,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          55,
                          62
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": null,
                      "current": {
                        "value": 601,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": null,
                      "current": {
                        "value": 580,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": null,
                        "percent": null
                      },
                      "current": {
                        "value": 160,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -16,
                        "columns": [
                          425,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          137,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -31,
                        "columns": [
                          55,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -29,
                        "columns": [
                          -17,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 11,
                        "columns": [
                          474,
                          425
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -50,
                        "columns": [
                          68,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          55,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -17,
                          -17
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 13,
                        "columns": [
                          122,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -35,
                        "columns": [
                          18,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 26,
                        "columns": [
                          26,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -6,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          419
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          82
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          61
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -35
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LQ"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": null,
                      "current": {
                        "value": 425,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": null,
                      "current": {
                        "value": 474,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": null,
                        "percent": null
                      },
                      "current": {
                        "value": 122,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -16,
                        "columns": [
                          425,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          137,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -31,
                        "columns": [
                          55,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -29,
                        "columns": [
                          -17,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 11,
                        "columns": [
                          474,
                          425
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -50,
                        "columns": [
                          68,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          55,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -17,
                          -17
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 13,
                        "columns": [
                          122,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -35,
                        "columns": [
                          18,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 26,
                        "columns": [
                          26,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -6,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          419
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          82
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          61
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -35
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LQ"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": null,
                      "current": {
                        "value": 137,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": null,
                      "current": {
                        "value": 68,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": null,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -16,
                        "columns": [
                          425,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          137,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -31,
                        "columns": [
                          55,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -29,
                        "columns": [
                          -17,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 11,
                        "columns": [
                          474,
                          425
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -50,
                        "columns": [
                          68,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          55,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -17,
                          -17
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 13,
                        "columns": [
                          122,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -35,
                        "columns": [
                          18,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 26,
                        "columns": [
                          26,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -6,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          419
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          82
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          61
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -35
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LQ"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": null,
                      "current": {
                        "value": 55,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": null,
                      "current": {
                        "value": 55,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": null,
                        "percent": null
                      },
                      "current": {
                        "value": 26,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -16,
                        "columns": [
                          425,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          137,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -31,
                        "columns": [
                          55,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -29,
                        "columns": [
                          -17,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 11,
                        "columns": [
                          474,
                          425
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -50,
                        "columns": [
                          68,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          55,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -17,
                          -17
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 13,
                        "columns": [
                          122,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -35,
                        "columns": [
                          18,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 26,
                        "columns": [
                          26,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -6,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          419
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          82
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          61
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -35
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LQ"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": null,
                      "current": {
                        "value": -17,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": null,
                      "current": {
                        "value": -17,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": null,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -16,
                        "columns": [
                          425,
                          508
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          137,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -31,
                        "columns": [
                          55,
                          79
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -29,
                        "columns": [
                          -17,
                          -24
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 11,
                        "columns": [
                          474,
                          425
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -50,
                        "columns": [
                          68,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          55,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -17,
                          -17
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 13,
                        "columns": [
                          122,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -35,
                        "columns": [
                          18,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 26,
                        "columns": [
                          26,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -6,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LQ"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          419
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          82
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          61
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -35
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LQ"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 651,
                        "percent": null
                      },
                      "current": {
                        "value": 601,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 636,
                        "percent": null
                      },
                      "current": {
                        "value": 580,
                        "percent": -9
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 711,
                        "percent": null
                      },
                      "current": {
                        "value": 160,
                        "percent": -32
                      },
                      "partial": {
                        "value": 237,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 631,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 7,
                        "columns": [
                          474,
                          443
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -43,
                        "columns": [
                          68,
                          119
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          55,
                          74
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          446
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          110
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          75
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 440,
                        "percent": null
                      },
                      "current": {
                        "value": 425,
                        "percent": -3
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 443,
                        "percent": null
                      },
                      "current": {
                        "value": 474,
                        "percent": 7
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 522,
                        "percent": null
                      },
                      "current": {
                        "value": 122,
                        "percent": -30
                      },
                      "partial": {
                        "value": 174,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 446,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 7,
                        "columns": [
                          474,
                          443
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -43,
                        "columns": [
                          68,
                          119
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          55,
                          74
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          446
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          110
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          75
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 138,
                        "percent": null
                      },
                      "current": {
                        "value": 137,
                        "percent": 0
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 119,
                        "percent": null
                      },
                      "current": {
                        "value": 68,
                        "percent": -43
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 114,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -52
                      },
                      "partial": {
                        "value": 38,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 110,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 7,
                        "columns": [
                          474,
                          443
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -43,
                        "columns": [
                          68,
                          119
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          55,
                          74
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          446
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          110
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          75
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 73,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -25
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 74,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -26
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 75,
                        "percent": null
                      },
                      "current": {
                        "value": 26,
                        "percent": 2
                      },
                      "partial": {
                        "value": 25,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 75,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 7,
                        "columns": [
                          474,
                          443
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -43,
                        "columns": [
                          68,
                          119
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          55,
                          74
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          446
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          110
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          75
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q1",
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q2",
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q3",
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": -999
                      },
                      "partial": {
                        "value": 0,
                        "percent": null
                      },
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": "Q4",
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": "Q1",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q2",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 7,
                        "columns": [
                          474,
                          443
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -43,
                        "columns": [
                          68,
                          119
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          55,
                          74
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q3",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": "Q4",
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          446
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          110
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          75
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ],
      "ytd": [
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 108,
                        "percent": null
                      },
                      "current": {
                        "value": 146,
                        "percent": 35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 352,
                        "percent": null
                      },
                      "current": {
                        "value": 287,
                        "percent": -18
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 795,
                        "percent": null
                      },
                      "current": {
                        "value": 601,
                        "percent": -24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 963,
                        "percent": null
                      },
                      "current": {
                        "value": 734,
                        "percent": -24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 1374,
                        "percent": null
                      },
                      "current": {
                        "value": 929,
                        "percent": -32
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 1746,
                        "percent": null
                      },
                      "current": {
                        "value": 1181,
                        "percent": -32
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 1998,
                        "percent": null
                      },
                      "current": {
                        "value": 1289,
                        "percent": -35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 2272,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 2600,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 2739,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 3027,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 3313,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -32,
                        "columns": [
                          190,
                          277
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 83,
                        "columns": [
                          79,
                          43
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          30,
                          45
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 16,
                        "columns": [
                          -11,
                          -13
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          515,
                          717
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -11,
                        "columns": [
                          166,
                          186
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -13,
                        "columns": [
                          75,
                          86
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 13,
                        "columns": [
                          -22,
                          -25
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          683,
                          1058
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          181,
                          238
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          92,
                          109
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -27,
                          -32
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -33,
                        "columns": [
                          899,
                          1333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -36,
                        "columns": [
                          206,
                          321
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          110,
                          129
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -34,
                          -38
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -37,
                        "columns": [
                          969,
                          1546
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -34,
                        "columns": [
                          224,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -14,
                        "columns": [
                          135,
                          158
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -39,
                          -47
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1762
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          382
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -56
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2017
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          435
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          211
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -63
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2098
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          476
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -69
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2311
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          529
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          267
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -79
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2525
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          584
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          290
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -86
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 76,
                        "percent": null
                      },
                      "current": {
                        "value": 94,
                        "percent": 24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 277,
                        "percent": null
                      },
                      "current": {
                        "value": 190,
                        "percent": -32
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 610,
                        "percent": null
                      },
                      "current": {
                        "value": 425,
                        "percent": -30
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 717,
                        "percent": null
                      },
                      "current": {
                        "value": 515,
                        "percent": -28
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 1058,
                        "percent": null
                      },
                      "current": {
                        "value": 683,
                        "percent": -35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 1333,
                        "percent": null
                      },
                      "current": {
                        "value": 899,
                        "percent": -33
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 1546,
                        "percent": null
                      },
                      "current": {
                        "value": 969,
                        "percent": -37
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 1762,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 2017,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 2098,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 2311,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 2525,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -32,
                        "columns": [
                          190,
                          277
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 83,
                        "columns": [
                          79,
                          43
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          30,
                          45
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 16,
                        "columns": [
                          -11,
                          -13
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          515,
                          717
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -11,
                        "columns": [
                          166,
                          186
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -13,
                        "columns": [
                          75,
                          86
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 13,
                        "columns": [
                          -22,
                          -25
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          683,
                          1058
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          181,
                          238
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          92,
                          109
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -27,
                          -32
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -33,
                        "columns": [
                          899,
                          1333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -36,
                        "columns": [
                          206,
                          321
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          110,
                          129
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -34,
                          -38
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -37,
                        "columns": [
                          969,
                          1546
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -34,
                        "columns": [
                          224,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -14,
                        "columns": [
                          135,
                          158
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -39,
                          -47
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1762
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          382
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -56
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2017
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          435
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          211
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -63
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2098
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          476
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -69
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2311
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          529
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          267
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -79
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2525
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          584
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          290
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -86
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 42,
                        "percent": 115
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 43,
                        "percent": null
                      },
                      "current": {
                        "value": 79,
                        "percent": 83
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 137,
                        "percent": null
                      },
                      "current": {
                        "value": 137,
                        "percent": 0
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 186,
                        "percent": null
                      },
                      "current": {
                        "value": 166,
                        "percent": -11
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 238,
                        "percent": null
                      },
                      "current": {
                        "value": 181,
                        "percent": -24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 321,
                        "percent": null
                      },
                      "current": {
                        "value": 206,
                        "percent": -36
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 341,
                        "percent": null
                      },
                      "current": {
                        "value": 224,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 382,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 435,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 476,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 529,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 584,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -32,
                        "columns": [
                          190,
                          277
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 83,
                        "columns": [
                          79,
                          43
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          30,
                          45
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 16,
                        "columns": [
                          -11,
                          -13
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          515,
                          717
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -11,
                        "columns": [
                          166,
                          186
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -13,
                        "columns": [
                          75,
                          86
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 13,
                        "columns": [
                          -22,
                          -25
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          683,
                          1058
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          181,
                          238
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          92,
                          109
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -27,
                          -32
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -33,
                        "columns": [
                          899,
                          1333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -36,
                        "columns": [
                          206,
                          321
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          110,
                          129
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -34,
                          -38
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -37,
                        "columns": [
                          969,
                          1546
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -34,
                        "columns": [
                          224,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -14,
                        "columns": [
                          135,
                          158
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -39,
                          -47
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1762
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          382
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -56
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2017
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          435
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          211
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -63
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2098
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          476
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -69
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2311
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          529
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          267
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -79
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2525
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          584
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          290
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -86
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 16,
                        "percent": -22
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 45,
                        "percent": null
                      },
                      "current": {
                        "value": 30,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 67,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -18
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 86,
                        "percent": null
                      },
                      "current": {
                        "value": 75,
                        "percent": -13
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 109,
                        "percent": null
                      },
                      "current": {
                        "value": 92,
                        "percent": -16
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 129,
                        "percent": null
                      },
                      "current": {
                        "value": 110,
                        "percent": -15
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 158,
                        "percent": null
                      },
                      "current": {
                        "value": 135,
                        "percent": -14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 185,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 211,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 235,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 267,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 290,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -32,
                        "columns": [
                          190,
                          277
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 83,
                        "columns": [
                          79,
                          43
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          30,
                          45
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 16,
                        "columns": [
                          -11,
                          -13
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          515,
                          717
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -11,
                        "columns": [
                          166,
                          186
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -13,
                        "columns": [
                          75,
                          86
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 13,
                        "columns": [
                          -22,
                          -25
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          683,
                          1058
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          181,
                          238
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          92,
                          109
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -27,
                          -32
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -33,
                        "columns": [
                          899,
                          1333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -36,
                        "columns": [
                          206,
                          321
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          110,
                          129
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -34,
                          -38
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -37,
                        "columns": [
                          969,
                          1546
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -34,
                        "columns": [
                          224,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -14,
                        "columns": [
                          135,
                          158
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -39,
                          -47
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1762
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          382
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -56
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2017
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          435
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          211
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -63
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2098
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          476
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -69
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2311
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          529
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          267
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -79
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2525
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          584
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          290
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -86
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": -7,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": 23
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": -13,
                        "percent": null
                      },
                      "current": {
                        "value": -11,
                        "percent": 16
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": -19,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": 12
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": -25,
                        "percent": null
                      },
                      "current": {
                        "value": -22,
                        "percent": 13
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": -32,
                        "percent": null
                      },
                      "current": {
                        "value": -27,
                        "percent": 14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": -38,
                        "percent": null
                      },
                      "current": {
                        "value": -34,
                        "percent": 11
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": -47,
                        "percent": null
                      },
                      "current": {
                        "value": -39,
                        "percent": 17
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": -56,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": -63,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": -69,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": -79,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": -86,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -32,
                        "columns": [
                          190,
                          277
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 83,
                        "columns": [
                          79,
                          43
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          30,
                          45
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 16,
                        "columns": [
                          -11,
                          -13
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          425,
                          610
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          137
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -18,
                        "columns": [
                          55,
                          67
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 12,
                        "columns": [
                          -17,
                          -19
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          515,
                          717
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -11,
                        "columns": [
                          166,
                          186
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -13,
                        "columns": [
                          75,
                          86
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 13,
                        "columns": [
                          -22,
                          -25
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          683,
                          1058
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          181,
                          238
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          92,
                          109
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 14,
                        "columns": [
                          -27,
                          -32
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -33,
                        "columns": [
                          899,
                          1333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -36,
                        "columns": [
                          206,
                          321
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          110,
                          129
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 11,
                        "columns": [
                          -34,
                          -38
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -37,
                        "columns": [
                          969,
                          1546
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -34,
                        "columns": [
                          224,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -14,
                        "columns": [
                          135,
                          158
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -39,
                          -47
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1762
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          382
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          185
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -56
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2017
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          435
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          211
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -63
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2098
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          476
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -69
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2311
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          529
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          267
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -79
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          2525
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          584
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          290
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -86
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 146,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 287,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 601,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 734,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 929,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 1181,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 1289,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          94,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          42,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          16,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -6,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          190,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          79,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          30,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -11,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          425,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          137,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          55,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -17,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          515,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          166,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          75,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -22,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          683,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          181,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          92,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -27,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          899,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          206,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          110,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -34,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          969,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          224,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          135,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -39,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 94,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 190,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 425,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 515,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 683,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 899,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 969,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          94,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          42,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          16,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -6,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          190,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          79,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          30,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -11,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          425,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          137,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          55,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -17,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          515,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          166,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          75,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -22,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          683,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          181,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          92,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -27,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          899,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          206,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          110,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -34,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          969,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          224,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          135,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -39,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 42,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 79,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 137,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 166,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 181,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 206,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 224,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          94,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          42,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          16,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -6,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          190,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          79,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          30,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -11,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          425,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          137,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          55,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -17,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          515,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          166,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          75,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -22,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          683,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          181,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          92,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -27,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          899,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          206,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          110,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -34,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          969,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          224,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          135,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -39,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 16,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 30,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 55,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 75,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 92,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 110,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 135,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          94,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          42,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          16,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -6,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          190,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          79,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          30,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -11,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          425,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          137,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          55,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -17,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          515,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          166,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          75,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -22,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          683,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          181,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          92,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -27,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          899,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          206,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          110,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -34,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          969,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          224,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          135,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -39,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": -6,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": -11,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": -17,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": -22,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": -27,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": -34,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": -39,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          94,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          42,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          16,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -6,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          190,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          79,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          30,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -11,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          425,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          137,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          55,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -17,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          515,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          166,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          75,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -22,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          683,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          181,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          92,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -27,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          899,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          206,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          110,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -34,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          969,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          224,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          135,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          -39,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      null
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          null
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      null
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 217,
                        "percent": null
                      },
                      "current": {
                        "value": 146,
                        "percent": -33
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 433,
                        "percent": null
                      },
                      "current": {
                        "value": 287,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 651,
                        "percent": null
                      },
                      "current": {
                        "value": 601,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 862,
                        "percent": null
                      },
                      "current": {
                        "value": 734,
                        "percent": -15
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 1074,
                        "percent": null
                      },
                      "current": {
                        "value": 929,
                        "percent": -14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 1287,
                        "percent": null
                      },
                      "current": {
                        "value": 1181,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 1524,
                        "percent": null
                      },
                      "current": {
                        "value": 1289,
                        "percent": -15
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 1761,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 1998,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 2208,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 2419,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 2629,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          190,
                          293
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -14,
                        "columns": [
                          79,
                          92
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -38,
                        "columns": [
                          30,
                          48
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -11,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -12,
                        "columns": [
                          515,
                          588
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          166,
                          177
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -23,
                        "columns": [
                          75,
                          97
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -22,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -7,
                        "columns": [
                          683,
                          735
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -17,
                        "columns": [
                          181,
                          217
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          92,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -27,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          899,
                          883
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          206,
                          257
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          110,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -34,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -8,
                        "columns": [
                          969,
                          1057
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          224,
                          295
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -21,
                        "columns": [
                          135,
                          172
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -39,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1231
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          197
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1405
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          371
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          222
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1554
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          407
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          247
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1703
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          444
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          272
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1851
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          481
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          297
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 147,
                        "percent": null
                      },
                      "current": {
                        "value": 94,
                        "percent": -36
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 293,
                        "percent": null
                      },
                      "current": {
                        "value": 190,
                        "percent": -35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 440,
                        "percent": null
                      },
                      "current": {
                        "value": 425,
                        "percent": -3
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 588,
                        "percent": null
                      },
                      "current": {
                        "value": 515,
                        "percent": -12
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 735,
                        "percent": null
                      },
                      "current": {
                        "value": 683,
                        "percent": -7
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 883,
                        "percent": null
                      },
                      "current": {
                        "value": 899,
                        "percent": 2
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 1057,
                        "percent": null
                      },
                      "current": {
                        "value": 969,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 1231,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 1405,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 1554,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 1703,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 1851,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          190,
                          293
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -14,
                        "columns": [
                          79,
                          92
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -38,
                        "columns": [
                          30,
                          48
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -11,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -12,
                        "columns": [
                          515,
                          588
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          166,
                          177
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -23,
                        "columns": [
                          75,
                          97
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -22,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -7,
                        "columns": [
                          683,
                          735
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -17,
                        "columns": [
                          181,
                          217
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          92,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -27,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          899,
                          883
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          206,
                          257
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          110,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -34,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -8,
                        "columns": [
                          969,
                          1057
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          224,
                          295
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -21,
                        "columns": [
                          135,
                          172
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -39,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1231
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          197
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1405
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          371
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          222
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1554
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          407
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          247
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1703
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          444
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          272
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1851
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          481
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          297
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 46,
                        "percent": null
                      },
                      "current": {
                        "value": 42,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 92,
                        "percent": null
                      },
                      "current": {
                        "value": 79,
                        "percent": -14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 138,
                        "percent": null
                      },
                      "current": {
                        "value": 137,
                        "percent": 0
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 177,
                        "percent": null
                      },
                      "current": {
                        "value": 166,
                        "percent": -6
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 217,
                        "percent": null
                      },
                      "current": {
                        "value": 181,
                        "percent": -17
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 257,
                        "percent": null
                      },
                      "current": {
                        "value": 206,
                        "percent": -20
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 295,
                        "percent": null
                      },
                      "current": {
                        "value": 224,
                        "percent": -24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 333,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 371,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 407,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 444,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 481,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          190,
                          293
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -14,
                        "columns": [
                          79,
                          92
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -38,
                        "columns": [
                          30,
                          48
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -11,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -12,
                        "columns": [
                          515,
                          588
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          166,
                          177
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -23,
                        "columns": [
                          75,
                          97
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -22,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -7,
                        "columns": [
                          683,
                          735
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -17,
                        "columns": [
                          181,
                          217
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          92,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -27,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          899,
                          883
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          206,
                          257
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          110,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -34,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -8,
                        "columns": [
                          969,
                          1057
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          224,
                          295
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -21,
                        "columns": [
                          135,
                          172
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -39,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1231
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          197
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1405
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          371
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          222
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1554
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          407
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          247
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1703
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          444
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          272
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1851
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          481
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          297
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 24,
                        "percent": null
                      },
                      "current": {
                        "value": 16,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 48,
                        "percent": null
                      },
                      "current": {
                        "value": 30,
                        "percent": -38
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 73,
                        "percent": null
                      },
                      "current": {
                        "value": 55,
                        "percent": -25
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 97,
                        "percent": null
                      },
                      "current": {
                        "value": 75,
                        "percent": -23
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 122,
                        "percent": null
                      },
                      "current": {
                        "value": 92,
                        "percent": -25
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 147,
                        "percent": null
                      },
                      "current": {
                        "value": 110,
                        "percent": -25
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 172,
                        "percent": null
                      },
                      "current": {
                        "value": 135,
                        "percent": -21
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 197,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 222,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 247,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 272,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 297,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          190,
                          293
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -14,
                        "columns": [
                          79,
                          92
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -38,
                        "columns": [
                          30,
                          48
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -11,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -12,
                        "columns": [
                          515,
                          588
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          166,
                          177
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -23,
                        "columns": [
                          75,
                          97
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -22,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -7,
                        "columns": [
                          683,
                          735
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -17,
                        "columns": [
                          181,
                          217
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          92,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -27,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          899,
                          883
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          206,
                          257
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          110,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -34,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -8,
                        "columns": [
                          969,
                          1057
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          224,
                          295
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -21,
                        "columns": [
                          135,
                          172
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -39,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1231
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          197
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1405
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          371
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          222
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1554
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          407
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          247
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1703
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          444
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          272
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1851
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          481
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          297
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -11,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -17,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -22,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -27,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -34,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -39,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -35,
                        "columns": [
                          190,
                          293
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -14,
                        "columns": [
                          79,
                          92
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -38,
                        "columns": [
                          30,
                          48
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -11,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -3,
                        "columns": [
                          425,
                          440
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 0,
                        "columns": [
                          137,
                          138
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          55,
                          73
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -17,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -12,
                        "columns": [
                          515,
                          588
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          166,
                          177
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -23,
                        "columns": [
                          75,
                          97
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -22,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -7,
                        "columns": [
                          683,
                          735
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -17,
                        "columns": [
                          181,
                          217
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          92,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -27,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          899,
                          883
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          206,
                          257
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -25,
                        "columns": [
                          110,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -34,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -8,
                        "columns": [
                          969,
                          1057
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -24,
                        "columns": [
                          224,
                          295
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -21,
                        "columns": [
                          135,
                          172
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -39,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1231
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          197
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1405
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          371
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          222
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1554
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          407
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          247
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1703
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          444
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          272
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          1851
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          481
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          297
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ],
      "month": [
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 108,
                        "percent": null
                      },
                      "current": {
                        "value": 146,
                        "percent": 35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 244,
                        "percent": null
                      },
                      "current": {
                        "value": 141,
                        "percent": -42
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 443,
                        "percent": null
                      },
                      "current": {
                        "value": 314,
                        "percent": -29
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 168,
                        "percent": null
                      },
                      "current": {
                        "value": 152,
                        "percent": -10
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 411,
                        "percent": null
                      },
                      "current": {
                        "value": 195,
                        "percent": -53
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 373,
                        "percent": null
                      },
                      "current": {
                        "value": 234,
                        "percent": -37
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 252,
                        "percent": null
                      },
                      "current": {
                        "value": 160,
                        "percent": -36
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 274,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 328,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 139,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 288,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 286,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -52,
                        "columns": [
                          96,
                          202
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 57,
                        "columns": [
                          37,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -44,
                        "columns": [
                          14,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 6,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -29,
                        "columns": [
                          235,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          59,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 15,
                        "columns": [
                          25,
                          22
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 1,
                        "columns": [
                          108,
                          107
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -42,
                        "columns": [
                          28,
                          49
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 5,
                        "columns": [
                          20,
                          19
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 18,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -51,
                        "columns": [
                          167,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          15,
                          52
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          17,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          199,
                          275
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          25,
                          84
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -8,
                        "columns": [
                          -7,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          215
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          27
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -8
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          256
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          80
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          32
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 76,
                        "percent": null
                      },
                      "current": {
                        "value": 94,
                        "percent": 24
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 202,
                        "percent": null
                      },
                      "current": {
                        "value": 96,
                        "percent": -52
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 333,
                        "percent": null
                      },
                      "current": {
                        "value": 235,
                        "percent": -29
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 107,
                        "percent": null
                      },
                      "current": {
                        "value": 108,
                        "percent": 1
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 341,
                        "percent": null
                      },
                      "current": {
                        "value": 167,
                        "percent": -51
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 275,
                        "percent": null
                      },
                      "current": {
                        "value": 199,
                        "percent": -28
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 213,
                        "percent": null
                      },
                      "current": {
                        "value": 122,
                        "percent": -43
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 215,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 256,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 80,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 213,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 214,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -52,
                        "columns": [
                          96,
                          202
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 57,
                        "columns": [
                          37,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -44,
                        "columns": [
                          14,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 6,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -29,
                        "columns": [
                          235,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          59,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 15,
                        "columns": [
                          25,
                          22
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 1,
                        "columns": [
                          108,
                          107
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -42,
                        "columns": [
                          28,
                          49
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 5,
                        "columns": [
                          20,
                          19
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 18,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -51,
                        "columns": [
                          167,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          15,
                          52
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          17,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          199,
                          275
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          25,
                          84
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -8,
                        "columns": [
                          -7,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          215
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          27
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -8
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          256
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          80
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          32
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 42,
                        "percent": 115
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 23,
                        "percent": null
                      },
                      "current": {
                        "value": 37,
                        "percent": 57
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 94,
                        "percent": null
                      },
                      "current": {
                        "value": 59,
                        "percent": -38
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 49,
                        "percent": null
                      },
                      "current": {
                        "value": 28,
                        "percent": -42
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 52,
                        "percent": null
                      },
                      "current": {
                        "value": 15,
                        "percent": -71
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 84,
                        "percent": null
                      },
                      "current": {
                        "value": 25,
                        "percent": -71
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -6
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 41,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 53,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 41,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 53,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 55,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -52,
                        "columns": [
                          96,
                          202
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 57,
                        "columns": [
                          37,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -44,
                        "columns": [
                          14,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 6,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -29,
                        "columns": [
                          235,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          59,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 15,
                        "columns": [
                          25,
                          22
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 1,
                        "columns": [
                          108,
                          107
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -42,
                        "columns": [
                          28,
                          49
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 5,
                        "columns": [
                          20,
                          19
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 18,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -51,
                        "columns": [
                          167,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          15,
                          52
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          17,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          199,
                          275
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          25,
                          84
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -8,
                        "columns": [
                          -7,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          215
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          27
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -8
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          256
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          80
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          32
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 16,
                        "percent": -22
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": 14,
                        "percent": -44
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 22,
                        "percent": null
                      },
                      "current": {
                        "value": 25,
                        "percent": 15
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 19,
                        "percent": null
                      },
                      "current": {
                        "value": 20,
                        "percent": 5
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 23,
                        "percent": null
                      },
                      "current": {
                        "value": 17,
                        "percent": -26
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 20,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -12
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 29,
                        "percent": null
                      },
                      "current": {
                        "value": 26,
                        "percent": -11
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 27,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 26,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 24,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 32,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 23,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -52,
                        "columns": [
                          96,
                          202
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 57,
                        "columns": [
                          37,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -44,
                        "columns": [
                          14,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 6,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -29,
                        "columns": [
                          235,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          59,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 15,
                        "columns": [
                          25,
                          22
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 1,
                        "columns": [
                          108,
                          107
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -42,
                        "columns": [
                          28,
                          49
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 5,
                        "columns": [
                          20,
                          19
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 18,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -51,
                        "columns": [
                          167,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          15,
                          52
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          17,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          199,
                          275
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          25,
                          84
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -8,
                        "columns": [
                          -7,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          215
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          27
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -8
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          256
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          80
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          32
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": -7,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": 23
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": -6,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": 6
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": -6,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": 4
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": -6,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": 18
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": -6,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": 17
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": -6,
                        "percent": null
                      },
                      "current": {
                        "value": -7,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": -10,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": 43
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": -8,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": -7,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": -7,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": -10,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": -7,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 24,
                        "columns": [
                          94,
                          76
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 115,
                        "columns": [
                          42,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -22,
                        "columns": [
                          16,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 23,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -52,
                        "columns": [
                          96,
                          202
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 57,
                        "columns": [
                          37,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -44,
                        "columns": [
                          14,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 6,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -29,
                        "columns": [
                          235,
                          333
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          59,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 15,
                        "columns": [
                          25,
                          22
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 1,
                        "columns": [
                          108,
                          107
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -42,
                        "columns": [
                          28,
                          49
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 5,
                        "columns": [
                          20,
                          19
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 18,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -51,
                        "columns": [
                          167,
                          341
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          15,
                          52
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -26,
                        "columns": [
                          17,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 17,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -28,
                        "columns": [
                          199,
                          275
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -71,
                        "columns": [
                          25,
                          84
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -8,
                        "columns": [
                          -7,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -43,
                        "columns": [
                          122,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -6,
                        "columns": [
                          18,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -11,
                        "columns": [
                          26,
                          29
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 43,
                        "columns": [
                          -6,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LY"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          215
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          27
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -8
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          256
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          80
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          41
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          213
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          53
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          32
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -10
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LY"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 146,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 141,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 314,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 152,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 195,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 234,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 160,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -56,
                        "columns": [
                          94,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -23,
                        "columns": [
                          42,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          16,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -18,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          96,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -13,
                        "columns": [
                          37,
                          42
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          14,
                          16
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 145,
                        "columns": [
                          235,
                          96
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          59,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 81,
                        "columns": [
                          25,
                          14
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -54,
                        "columns": [
                          108,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          28,
                          59
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -19,
                        "columns": [
                          20,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -7,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 55,
                        "columns": [
                          167,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -46,
                        "columns": [
                          15,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          17,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 3,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 19,
                        "columns": [
                          199,
                          167
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          25,
                          15
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 3,
                        "columns": [
                          18,
                          17
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 26,
                        "columns": [
                          -7,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -39,
                        "columns": [
                          122,
                          199
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -26,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 46,
                        "columns": [
                          26,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -14,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 94,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 96,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 235,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 108,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 167,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 199,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 122,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -56,
                        "columns": [
                          94,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -23,
                        "columns": [
                          42,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          16,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -18,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          96,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -13,
                        "columns": [
                          37,
                          42
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          14,
                          16
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 145,
                        "columns": [
                          235,
                          96
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          59,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 81,
                        "columns": [
                          25,
                          14
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -54,
                        "columns": [
                          108,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          28,
                          59
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -19,
                        "columns": [
                          20,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -7,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 55,
                        "columns": [
                          167,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -46,
                        "columns": [
                          15,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          17,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 3,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 19,
                        "columns": [
                          199,
                          167
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          25,
                          15
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 3,
                        "columns": [
                          18,
                          17
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 26,
                        "columns": [
                          -7,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -39,
                        "columns": [
                          122,
                          199
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -26,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 46,
                        "columns": [
                          26,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -14,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 42,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 37,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 59,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 28,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 15,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 25,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 18,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -56,
                        "columns": [
                          94,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -23,
                        "columns": [
                          42,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          16,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -18,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          96,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -13,
                        "columns": [
                          37,
                          42
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          14,
                          16
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 145,
                        "columns": [
                          235,
                          96
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          59,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 81,
                        "columns": [
                          25,
                          14
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -54,
                        "columns": [
                          108,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          28,
                          59
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -19,
                        "columns": [
                          20,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -7,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 55,
                        "columns": [
                          167,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -46,
                        "columns": [
                          15,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          17,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 3,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 19,
                        "columns": [
                          199,
                          167
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          25,
                          15
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 3,
                        "columns": [
                          18,
                          17
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 26,
                        "columns": [
                          -7,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -39,
                        "columns": [
                          122,
                          199
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -26,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 46,
                        "columns": [
                          26,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -14,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": 16,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": 14,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": 25,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": 20,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": 17,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": 18,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": 26,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -56,
                        "columns": [
                          94,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -23,
                        "columns": [
                          42,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          16,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -18,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          96,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -13,
                        "columns": [
                          37,
                          42
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          14,
                          16
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 145,
                        "columns": [
                          235,
                          96
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          59,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 81,
                        "columns": [
                          25,
                          14
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -54,
                        "columns": [
                          108,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          28,
                          59
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -19,
                        "columns": [
                          20,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -7,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 55,
                        "columns": [
                          167,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -46,
                        "columns": [
                          15,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          17,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 3,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 19,
                        "columns": [
                          199,
                          167
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          25,
                          15
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 3,
                        "columns": [
                          18,
                          17
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 26,
                        "columns": [
                          -7,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -39,
                        "columns": [
                          122,
                          199
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -26,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 46,
                        "columns": [
                          26,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -14,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": null,
                      "current": {
                        "value": -6,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": null,
                      "current": {
                        "value": -6,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": null,
                      "current": {
                        "value": -5,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": null,
                      "current": {
                        "value": -5,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": null,
                      "current": {
                        "value": -5,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": null,
                      "current": {
                        "value": -7,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": null,
                      "current": {
                        "value": -6,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": null,
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -56,
                        "columns": [
                          94,
                          214
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -23,
                        "columns": [
                          42,
                          55
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          16,
                          23
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -18,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 2,
                        "columns": [
                          96,
                          94
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -13,
                        "columns": [
                          37,
                          42
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -12,
                        "columns": [
                          14,
                          16
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 0,
                        "columns": [
                          -6,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 145,
                        "columns": [
                          235,
                          96
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          59,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 81,
                        "columns": [
                          25,
                          14
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -4,
                        "columns": [
                          -5,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -54,
                        "columns": [
                          108,
                          235
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          28,
                          59
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -19,
                        "columns": [
                          20,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -7,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 55,
                        "columns": [
                          167,
                          108
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -46,
                        "columns": [
                          15,
                          28
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -16,
                        "columns": [
                          17,
                          20
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 3,
                        "columns": [
                          -5,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 19,
                        "columns": [
                          199,
                          167
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 60,
                        "columns": [
                          25,
                          15
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 3,
                        "columns": [
                          18,
                          17
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": 26,
                        "columns": [
                          -7,
                          -5
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -39,
                        "columns": [
                          122,
                          199
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -26,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 46,
                        "columns": [
                          26,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -14,
                        "columns": [
                          -6,
                          -7
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "LM"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          122
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          18
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          26
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          -6
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "LM"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 217,
                        "percent": null
                      },
                      "current": {
                        "value": 146,
                        "percent": -33
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 216,
                        "percent": null
                      },
                      "current": {
                        "value": 141,
                        "percent": -35
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 218,
                        "percent": null
                      },
                      "current": {
                        "value": 314,
                        "percent": 44
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 211,
                        "percent": null
                      },
                      "current": {
                        "value": 152,
                        "percent": -28
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 212,
                        "percent": null
                      },
                      "current": {
                        "value": 195,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 213,
                        "percent": null
                      },
                      "current": {
                        "value": 234,
                        "percent": 10
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 237,
                        "percent": null
                      },
                      "current": {
                        "value": 160,
                        "percent": -32
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 237,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 237,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 210,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 211,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 210,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "Total",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          96,
                          146
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          37,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -42,
                        "columns": [
                          14,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 60,
                        "columns": [
                          235,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 28,
                        "columns": [
                          59,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          25,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -27,
                        "columns": [
                          108,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -27,
                        "columns": [
                          28,
                          39
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          20,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 14,
                        "columns": [
                          167,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -62,
                        "columns": [
                          15,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          17,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 34,
                        "columns": [
                          199,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          25,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -30,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -7,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          36
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 147,
                        "percent": null
                      },
                      "current": {
                        "value": 94,
                        "percent": -36
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 146,
                        "percent": null
                      },
                      "current": {
                        "value": 96,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 147,
                        "percent": null
                      },
                      "current": {
                        "value": 235,
                        "percent": 60
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 148,
                        "percent": null
                      },
                      "current": {
                        "value": 108,
                        "percent": -27
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 147,
                        "percent": null
                      },
                      "current": {
                        "value": 167,
                        "percent": 14
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 148,
                        "percent": null
                      },
                      "current": {
                        "value": 199,
                        "percent": 34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 174,
                        "percent": null
                      },
                      "current": {
                        "value": 122,
                        "percent": -30
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 174,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 174,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 149,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 149,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 148,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IL",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          96,
                          146
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          37,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -42,
                        "columns": [
                          14,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 60,
                        "columns": [
                          235,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 28,
                        "columns": [
                          59,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          25,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -27,
                        "columns": [
                          108,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -27,
                        "columns": [
                          28,
                          39
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          20,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 14,
                        "columns": [
                          167,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -62,
                        "columns": [
                          15,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          17,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 34,
                        "columns": [
                          199,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          25,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -30,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -7,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          36
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 46,
                        "percent": null
                      },
                      "current": {
                        "value": 42,
                        "percent": -8
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 46,
                        "percent": null
                      },
                      "current": {
                        "value": 37,
                        "percent": -20
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 46,
                        "percent": null
                      },
                      "current": {
                        "value": 59,
                        "percent": 28
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 39,
                        "percent": null
                      },
                      "current": {
                        "value": 28,
                        "percent": -27
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 40,
                        "percent": null
                      },
                      "current": {
                        "value": 15,
                        "percent": -62
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 40,
                        "percent": null
                      },
                      "current": {
                        "value": 25,
                        "percent": -38
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 38,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -52
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 38,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 38,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 36,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 37,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 37,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "IBP",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          96,
                          146
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          37,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -42,
                        "columns": [
                          14,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 60,
                        "columns": [
                          235,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 28,
                        "columns": [
                          59,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          25,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -27,
                        "columns": [
                          108,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -27,
                        "columns": [
                          28,
                          39
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          20,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 14,
                        "columns": [
                          167,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -62,
                        "columns": [
                          15,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          17,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 34,
                        "columns": [
                          199,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          25,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -30,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -7,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          36
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 24,
                        "percent": null
                      },
                      "current": {
                        "value": 16,
                        "percent": -34
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 24,
                        "percent": null
                      },
                      "current": {
                        "value": 14,
                        "percent": -42
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": 25,
                        "percent": 0
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 24,
                        "percent": null
                      },
                      "current": {
                        "value": 20,
                        "percent": -15
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": 17,
                        "percent": -32
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": 18,
                        "percent": -30
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": 26,
                        "percent": 2
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 25,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "DSM",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          96,
                          146
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          37,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -42,
                        "columns": [
                          14,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 60,
                        "columns": [
                          235,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 28,
                        "columns": [
                          59,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          25,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -27,
                        "columns": [
                          108,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -27,
                        "columns": [
                          28,
                          39
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          20,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 14,
                        "columns": [
                          167,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -62,
                        "columns": [
                          15,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          17,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 34,
                        "columns": [
                          199,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          25,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -30,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -7,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          36
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              },
              {
                "graph": {
                  "data": [
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 1,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 2,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 3,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 4,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 5,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -5,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 6,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -7,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 7,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": -6,
                        "percent": -999
                      },
                      "partial": null,
                      "isFuture": false,
                      "isDefault": true,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 8,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 9,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 10,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 11,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    },
                    {
                      "cif": null,
                      "fob": null,
                      "colName": 12,
                      "compare": {
                        "value": 0,
                        "percent": null
                      },
                      "current": {
                        "value": null,
                        "percent": null
                      },
                      "partial": null,
                      "isFuture": true,
                      "isDefault": false,
                      "colGroupName": null,
                      "isPreliminary": false
                    }
                  ],
                  "columnType": "M"
                },
                "title": "OTH",
                "battery": [
                  {
                    "title": 1,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -36,
                        "columns": [
                          94,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -8,
                        "columns": [
                          42,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -34,
                        "columns": [
                          16,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 2,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -34,
                        "columns": [
                          96,
                          146
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -20,
                        "columns": [
                          37,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -42,
                        "columns": [
                          14,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 3,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 60,
                        "columns": [
                          235,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": 28,
                        "columns": [
                          59,
                          46
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 0,
                        "columns": [
                          25,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 4,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -27,
                        "columns": [
                          108,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -27,
                        "columns": [
                          28,
                          39
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -15,
                        "columns": [
                          20,
                          24
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 5,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 14,
                        "columns": [
                          167,
                          147
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -62,
                        "columns": [
                          15,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -32,
                        "columns": [
                          17,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -5,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 6,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": 34,
                        "columns": [
                          199,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -38,
                        "columns": [
                          25,
                          40
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": -30,
                        "columns": [
                          18,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -7,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 7,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": -30,
                        "columns": [
                          122,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": -52,
                        "columns": [
                          18,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": 2,
                        "columns": [
                          26,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": -999,
                        "columns": [
                          -6,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      "ACT",
                      "BGT"
                    ]
                  },
                  {
                    "title": 8,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 9,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          174
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          38
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 10,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          36
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 11,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          149
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  },
                  {
                    "title": 12,
                    "columns": [
                      {
                        "size": null,
                        "title": "IL",
                        "value": null,
                        "columns": [
                          null,
                          148
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "IBP",
                        "value": null,
                        "columns": [
                          null,
                          37
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "DSM",
                        "value": null,
                        "columns": [
                          null,
                          25
                        ],
                        "negative": null
                      },
                      {
                        "size": null,
                        "title": "OTH",
                        "value": null,
                        "columns": [
                          null,
                          0
                        ],
                        "negative": null
                      }
                    ],
                    "colNames": [
                      null,
                      "BGT"
                    ]
                  }
                ]
              }
            ],
            "isMainGraph": false
          },
          "title": "BGT"
        }
      ]
    },
    "type": "GraphNavigation"
  }
};

const oiICLMock = {
    "title": "OI",
    "type": "OI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": -25.0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": -59.0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": null,
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -50.0,
                                                "columns": [
                                                    31.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 23.0,
                                                "columns": [
                                                    54.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -31.0,
                                                "columns": [
                                                    37.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -39.0,
                                                "columns": [
                                                    14.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -45.0,
                                                "columns": [
                                                    32.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -61.0,
                                                "columns": [
                                                    48.0,
                                                    124.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -36.0,
                                                "columns": [
                                                    34.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -85.0,
                                                "columns": [
                                                    4.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    68.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    243.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    44.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    68.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    78.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    262.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    91.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    234.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    152.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    196.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    147.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 169.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 262.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 448.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 460.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 420.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 317.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 306.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 305.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 135.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 202.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -5.0,
                                                "columns": [
                                                    31.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -62.0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -35.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 1.0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 6.0,
                                                "columns": [
                                                    32.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -11.0,
                                                "columns": [
                                                    48.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -10.0,
                                                "columns": [
                                                    34.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -71.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": 13.0
                                            },
                                            "compare": {
                                                "value": 169.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 107.0,
                                                "percent": -4.0
                                            },
                                            "compare": {
                                                "value": 262.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 448.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 460.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 420.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 317.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 306.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 305.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 135.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 202.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -7.0,
                                                "columns": [
                                                    31.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -40.0,
                                                "columns": [
                                                    54.0,
                                                    90.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 39.0,
                                                "columns": [
                                                    37.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -38.0,
                                                "columns": [
                                                    14.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -2.0,
                                                "columns": [
                                                    32.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -35.0,
                                                "columns": [
                                                    48.0,
                                                    74.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 30.0,
                                                "columns": [
                                                    34.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -83.0,
                                                "columns": [
                                                    4.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    60.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    88.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    25.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    36.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": -46.0
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 928.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -48.0,
                                                "columns": [
                                                    63.0,
                                                    120.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -39.0,
                                                "columns": [
                                                    102.0,
                                                    167.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -34.0,
                                                "columns": [
                                                    71.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -64.0,
                                                "columns": [
                                                    18.0,
                                                    49.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    188.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    410.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    200.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    191.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    576.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    268.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    154.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    496.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    193.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    112.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    95.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    340.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    116.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    32.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 928.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 1.0,
                                                "columns": [
                                                    63.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -49.0,
                                                "columns": [
                                                    102.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 22.0,
                                                "columns": [
                                                    71.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -4.0,
                                                "columns": [
                                                    18.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 928.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 562.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -5.0,
                                                "columns": [
                                                    63.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -38.0,
                                                "columns": [
                                                    102.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 34.0,
                                                "columns": [
                                                    71.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -61.0,
                                                "columns": [
                                                    18.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    103.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    241.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    81.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    71.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    303.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    86.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    106.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    262.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    65.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    66.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": -25.0
                                            },
                                            "compare": {
                                                "value": 169.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": -46.0
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1599.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2019.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2336.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2642.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2947.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3082.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3284.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -50.0,
                                                "columns": [
                                                    31.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 23.0,
                                                "columns": [
                                                    54.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -31.0,
                                                "columns": [
                                                    37.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -39.0,
                                                "columns": [
                                                    14.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -48.0,
                                                "columns": [
                                                    63.0,
                                                    120.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -39.0,
                                                "columns": [
                                                    102.0,
                                                    167.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -34.0,
                                                "columns": [
                                                    71.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -64.0,
                                                "columns": [
                                                    18.0,
                                                    49.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    188.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    410.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    200.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    257.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    490.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    278.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    324.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    751.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    369.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    188.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    379.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    986.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    468.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    234.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    438.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1134.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    541.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    279.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    492.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1286.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    600.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    328.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    533.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1482.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    661.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    346.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    562.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1534.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    698.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    365.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    596.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1682.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    720.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    364.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    628.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1822.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    777.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    378.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 169.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1599.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2019.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2336.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2642.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2947.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3082.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3284.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    31.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    54.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    14.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    63.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    102.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    71.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    18.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 128.0,
                                                "percent": 13.0
                                            },
                                            "compare": {
                                                "value": 169.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 235.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 432.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 880.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1139.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1599.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2019.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2336.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2642.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2947.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3082.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3284.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3509.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -7.0,
                                                "columns": [
                                                    31.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -40.0,
                                                "columns": [
                                                    54.0,
                                                    90.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 39.0,
                                                "columns": [
                                                    37.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -38.0,
                                                "columns": [
                                                    14.0,
                                                    22.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -5.0,
                                                "columns": [
                                                    63.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -38.0,
                                                "columns": [
                                                    102.0,
                                                    164.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 34.0,
                                                "columns": [
                                                    71.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -61.0,
                                                "columns": [
                                                    18.0,
                                                    45.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    133.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    307.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    90.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    167.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    395.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    202.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    488.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    161.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    138.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    239.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    581.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    163.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    691.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    218.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    188.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    314.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    791.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    214.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    349.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    871.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    269.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    236.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    385.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    967.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    290.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    258.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    420.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1053.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    312.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    280.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ]
        }
    }
};
const niICLMock = {
    "title": "Net Income",
    "type": "NI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": -33.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 61.0,
                                        "percent": -68.0
                                    },
                                    "compare": {
                                        "value": 190.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 309.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 325.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 247.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 205.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 212.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 158.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 61.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 190.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 309.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 325.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 247.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 205.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 212.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 158.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": 20.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 61.0,
                                        "percent": -7.0
                                    },
                                    "compare": {
                                        "value": 190.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 309.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 325.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 247.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 205.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 212.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 158.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": -33.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": -55.0
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 504.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 751.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 415.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 628.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 199.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 357.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 504.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 751.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 415.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 628.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 199.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 357.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": 20.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": 6.0
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 179.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 504.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 751.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 211.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 415.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 628.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 83.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 199.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 357.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": -33.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": -55.0
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 792.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1364.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1575.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1780.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1992.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2075.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2191.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2350.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 792.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1364.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1575.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1780.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1992.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 2075.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 2191.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 2350.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 77.0,
                                        "percent": 20.0
                                    },
                                    "compare": {
                                        "value": 114.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 137.0,
                                        "percent": 6.0
                                    },
                                    "compare": {
                                        "value": 305.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 613.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 792.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1117.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1364.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1575.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1780.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 1992.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2075.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2191.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 0
                                    },
                                    "compare": {
                                        "value": 2350.0,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        }
                    }
                }
            ]
        }
    }
};
const epsICLMock = {
    "title": "EPS Adj. Diluted",
    "type": "EPS",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.25,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.19,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 0.11,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": 1200024,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "May",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.25,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.19,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.11,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "adjustedNI": null,
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": 2222,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "adjustedNI": 333,
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 5678568,
                                "adjustedNI": 123,
                            },
                            {
                                "title": "May",
                                "dilutedShares": 123123,
                                "adjustedNI": 554,
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 423423,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 52352635,
                                "adjustedNI": 345,
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "adjustedNI": 672,
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "adjustedNI": 672,
                            }
                        ]
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.14,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.25,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.19,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.16,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.11,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": null,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": null,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "May",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.57,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.48,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 0.28,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.57,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.48,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.28,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.57,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.48,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.28,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.11,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290965.0
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.6,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 0.85,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291696.0
                                    },
                                    "compare": {
                                        "value": 1.06,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.21,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.37,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.54,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 1.61,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 1.69,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1291299.0
                                    },
                                    "compare": {
                                        "value": 1.82,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "May",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.11,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.6,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 0.85,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.06,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.21,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.37,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.54,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.61,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.69,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": null
                                    },
                                    "compare": {
                                        "value": 1.82,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "May",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": {
                            "columnType": "M",
                            "data": [
                                {
                                    "colName": "Jan",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.05,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.08,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Feb",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.11,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.23,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": true,
                                    "isFuture": false,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Mar",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.47,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Apr",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.6,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "May",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 0.85,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jun",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.06,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Jul",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.21,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Aug",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.37,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Sep",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.54,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Oct",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.61,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Nov",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.69,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                },
                                {
                                    "colName": "Dec",
                                    "colGroupName": 2023,
                                    "partial": null,
                                    "current": {
                                        "value": 0.0,
                                        "percent": 1290131.0
                                    },
                                    "compare": {
                                        "value": 1.82,
                                        "percent": null
                                    },
                                    "isPreliminary": false,
                                    "isDefault": false,
                                    "isFuture": true,
                                    "cif": null,
                                    "kmt": null
                                }
                            ]
                        },
                        "footer": [
                            {
                                "title": "Jan",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Feb",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Mar",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Apr",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "May",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jun",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Jul",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Aug",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Sep",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Oct",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Nov",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            },
                            {
                                "title": "Dec",
                                "dilutedShares": 1200023,
                                "dilutedSharesCompare": 1100001,
                                "adjustedNI": 672,
                                "adjustedNICompare": 276
                            }
                        ]
                    }
                }
            ]
        }
    }
};
const ebitdaICLMock = {
    "title": "EBITDA",
    "type": "EBITDA",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": -20.0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 151.0,
                                                "percent": -50.0
                                            },
                                            "compare": {
                                                "value": 301.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 490.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 299.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 501.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 458.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 356.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 346.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 347.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 176.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 243.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -46.0,
                                                "columns": [
                                                    36.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 19.0,
                                                "columns": [
                                                    69.0,
                                                    58.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -23.0,
                                                "columns": [
                                                    55.0,
                                                    71.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -44.0,
                                                "columns": [
                                                    15.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -42.0,
                                                "columns": [
                                                    37.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -55.0,
                                                "columns": [
                                                    62.0,
                                                    136.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -23.0,
                                                "columns": [
                                                    52.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -71.0,
                                                "columns": [
                                                    9.0,
                                                    32.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    257.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    109.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    92.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    47.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    72.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    275.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    107.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    59.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    115.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    162.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    88.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    60.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    167.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    73.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    55.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    209.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    67.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    24.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    162.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    37.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 151.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 301.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 490.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 299.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 501.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 458.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 356.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 346.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 347.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 176.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 243.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -4.0,
                                                "columns": [
                                                    36.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -56.0,
                                                "columns": [
                                                    69.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -28.0,
                                                "columns": [
                                                    55.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -44.0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 4.0,
                                                "columns": [
                                                    37.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -10.0,
                                                "columns": [
                                                    62.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -5.0,
                                                "columns": [
                                                    52.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -38.0,
                                                "columns": [
                                                    9.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": 8.0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 151.0,
                                                "percent": -3.0
                                            },
                                            "compare": {
                                                "value": 301.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 490.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 299.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 501.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 458.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 356.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 346.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 347.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 176.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 243.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 278.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -6.0,
                                                "columns": [
                                                    36.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -31.0,
                                                "columns": [
                                                    69.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 25.0,
                                                "columns": [
                                                    55.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -45.0,
                                                "columns": [
                                                    15.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -2.0,
                                                "columns": [
                                                    37.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -31.0,
                                                "columns": [
                                                    62.0,
                                                    90.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 21.0,
                                                "columns": [
                                                    52.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -66.0,
                                                "columns": [
                                                    9.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    95.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    98.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    45.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    117.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    120.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    46.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    96.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1258.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1049.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 698.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -44.0,
                                                "columns": [
                                                    73.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -33.0,
                                                "columns": [
                                                    130.0,
                                                    194.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -23.0,
                                                "columns": [
                                                    107.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -58.0,
                                                "columns": [
                                                    25.0,
                                                    59.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    203.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    450.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    206.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    616.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    315.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    155.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    170.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    537.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    239.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    127.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    385.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    165.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    56.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1258.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1049.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 698.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0.0,
                                                "columns": [
                                                    73.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -43.0,
                                                "columns": [
                                                    130.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 21.0,
                                                "columns": [
                                                    107.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -12.0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": 2.0
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1258.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1049.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 698.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -4.0,
                                                "columns": [
                                                    73.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -31.0,
                                                "columns": [
                                                    130.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 23.0,
                                                "columns": [
                                                    107.0,
                                                    87.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -56.0,
                                                "columns": [
                                                    25.0,
                                                    56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    119.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    286.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    132.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    87.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    128.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    351.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    137.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    93.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    122.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    310.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    116.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    82.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": -20.0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": -38.0
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1300.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1802.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2616.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2962.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3309.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3485.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3727.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4007.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -46.0,
                                                "columns": [
                                                    36.0,
                                                    66.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 19.0,
                                                "columns": [
                                                    69.0,
                                                    58.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -23.0,
                                                "columns": [
                                                    55.0,
                                                    71.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -44.0,
                                                "columns": [
                                                    15.0,
                                                    27.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -44.0,
                                                "columns": [
                                                    73.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -33.0,
                                                "columns": [
                                                    130.0,
                                                    194.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": -23.0,
                                                "columns": [
                                                    107.0,
                                                    139.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -58.0,
                                                "columns": [
                                                    25.0,
                                                    59.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    203.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    450.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    247.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    110.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    277.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    543.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    340.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    156.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    349.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    818.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    447.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    215.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    409.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1066.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    562.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    265.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    473.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1228.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    649.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    315.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    533.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1394.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    723.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    369.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    579.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1603.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    801.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    392.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    613.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1670.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    853.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    416.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    652.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1832.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    890.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    421.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    689.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1988.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    966.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    448.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1300.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 1802.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2616.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 2962.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3309.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3485.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 3727.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4007.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    36.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    69.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    55.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    15.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    73.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    130.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    107.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    25.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 168.0,
                                                "percent": 8.0
                                            },
                                            "compare": {
                                                "value": 211.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 319.0,
                                                "percent": 2.0
                                            },
                                            "compare": {
                                                "value": 512.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1002.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1300.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 1802.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2260.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2616.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2962.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3309.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3485.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3727.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4007.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -6.0,
                                                "columns": [
                                                    36.0,
                                                    38.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -31.0,
                                                "columns": [
                                                    69.0,
                                                    99.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 25.0,
                                                "columns": [
                                                    55.0,
                                                    44.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -45.0,
                                                "columns": [
                                                    15.0,
                                                    28.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": -4.0,
                                                "columns": [
                                                    73.0,
                                                    76.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": -31.0,
                                                "columns": [
                                                    130.0,
                                                    189.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 23.0,
                                                "columns": [
                                                    107.0,
                                                    87.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": -56.0,
                                                "columns": [
                                                    25.0,
                                                    56.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    83.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    154.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    384.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    175.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    112.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    194.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    479.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    219.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    141.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    233.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    577.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    263.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    170.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    276.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    691.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    308.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    201.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    318.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    808.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    354.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    232.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    361.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    928.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    400.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    263.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    402.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1030.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    439.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    291.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    443.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1142.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    478.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    318.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "IP",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    483.0
                                                ]
                                            },
                                            {
                                                "title": "POTASH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    1238.0
                                                ]
                                            },
                                            {
                                                "title": "PS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    516.0
                                                ]
                                            },
                                            {
                                                "title": "GS",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    345.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": true
                    }
                }
            ]
        }
    }
};
const topTenProductsMock = {
    title: 'Top 10 Products',
    type: GraphType.TOP_PRODUCTS,
    navigation: {
        type: 'GraphNavigation',
        nav: {
            month: [
                {
                    title: 'LY',
                    graph: {
                        data: [
                            {
                                title: 'POTASH',
                                value: {
                                    value: 233,
                                    positive: 1
                                },
                                kmt: {
                                    value: 1.548,
                                    positive: -1
                                },
                                price: {
                                    value: 425,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1200,
                                        salesCompare: 1200,
                                        positive: -1,
                                        graph: {
                                            "columnType": null,
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    dollarMT: {
                                        sales: 1300,
                                        salesCompare: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    mDollar: {
                                        sales: 1400,
                                        salesCompare: 1200,
                                        positive: 1,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                title: 'MAP',
                                value: {
                                    value: 230,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                            {
                                title: 'GPK',
                                value: {
                                    value: 220,
                                    positive: -1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: null
                            },
                            {
                                title: 'GPAC 4D',
                                value: {
                                    value: 210,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: null,
                                    mDollar: null
                                }
                            },
                            {
                                title: 'GTSP',
                                value: {
                                    value: 200,
                                    positive: 0
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    title: 'C',
                    graph: {
                        data: [
                            {
                                title: 'POTASH',
                                value: {
                                    value: 233,
                                    positive: 1
                                },
                                kmt: {
                                    value: 1.548,
                                    positive: -1
                                },
                                price: {
                                    value: 425,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": null,
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    dollarMT: {
                                        sales: 1300,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    mDollar: {
                                        sales: 1400,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                title: 'GTSP',
                                value: {
                                    value: 230,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                            {
                                title: 'GPK',
                                value: {
                                    value: 220,
                                    positive: -1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: null
                            },
                            {
                                title: 'GPAC 4D',
                                value: {
                                    value: 210,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: null,
                                    mDollar: null
                                }
                            },
                            {
                                title: 'MAP',
                                value: {
                                    value: 200,
                                    positive: 0
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                        ]
                    }
                },
            ],
            qtd: [
                {
                    title: 'LY',
                    graph: {
                        data: [
                            {
                                title: 'POTASH',
                                value: {
                                    value: 233,
                                    positive: 1
                                },
                                kmt: {
                                    value: 1.548,
                                    positive: -1
                                },
                                price: {
                                    value: 425,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1200,
                                        salesCompare: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": null,
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    dollarMT: {
                                        sales: 1300,
                                        salesCompare: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    mDollar: {
                                        sales: 1400,
                                        salesCompare: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "compare": {
                                                        "value": 50,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "compare": {
                                                        "value": 0,
                                                        "percent": null
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                title: 'test',
                                value: {
                                    value: 230,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                            {
                                title: 'GPK',
                                value: {
                                    value: 220,
                                    positive: -1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: null
                            },
                            {
                                title: 'GPAC 4D',
                                value: {
                                    value: 210,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: null,
                                    mDollar: null
                                }
                            },
                            {
                                title: 'GTSP',
                                value: {
                                    value: 200,
                                    positive: 0
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    title: 'C',
                    graph: {
                        data: [
                            {
                                title: 'POTASH',
                                value: {
                                    value: 233,
                                    positive: 1
                                },
                                kmt: {
                                    value: 1.548,
                                    positive: -1
                                },
                                price: {
                                    value: 425,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1200,
                                        positive: 0,
                                        graph: {
                                            "columnType": null,
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    dollarMT: {
                                        sales: 1300,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    },
                                    mDollar: {
                                        sales: 1400,
                                        positive: 0,
                                        graph: {
                                            "columnType": "M",
                                            "data": [
                                                {
                                                    "colName": "Q1",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q2",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q3",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 62,
                                                        "percent": 12
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": true,
                                                    "isFuture": false,
                                                },
                                                {
                                                    "colName": "Q4",
                                                    "colGroupName": null,
                                                    "partial": null,
                                                    "current": {
                                                        "value": 0,
                                                        "percent": 0
                                                    },
                                                    "isPreliminary": false,
                                                    "isDefault": false,
                                                    "isFuture": true,
                                                },
                                            ]
                                        }
                                    }
                                }
                            },
                            {
                                title: 'GTSP',
                                value: {
                                    value: 230,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                            {
                                title: 'GPK',
                                value: {
                                    value: 220,
                                    positive: -1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: null
                            },
                            {
                                title: 'GPAC 4D',
                                value: {
                                    value: 210,
                                    positive: 1
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: null,
                                    mDollar: null
                                }
                            },
                            {
                                title: 'MAP',
                                value: {
                                    value: 200,
                                    positive: 0
                                },
                                kmt: {
                                    value: 0,
                                    positive: 1
                                },
                                price: {
                                    value: 0,
                                    positive: 1
                                },
                                data: {
                                    kmt: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    dollarMT: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    },
                                    mDollar: {
                                        sales: 1,
                                        salesCompare: 1,
                                        positive: 1,
                                        graph: null
                                    }
                                }
                            },
                        ]
                    }
                },
            ],
        }
    }
};

const territoryICLMock = {
  "type": "TERRITORY",
  "title": "Sales by Territory",
  "subMenu": null,
  "navigation": {
    "nav": {
      "qtd": [
        {
          "graph": {
            "all": {
              "data": [
                {
                  "title": "Total",
                  "value": 606,
                  "percent": null
                },
                {
                  "title": "Brazil",
                  "value": 119,
                  "percent": "20"
                },
                {
                  "title": "China",
                  "value": 107,
                  "percent": "18"
                },
                {
                  "title": "USA",
                  "value": 79,
                  "percent": "13"
                },
                {
                  "title": "Germany",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "United Kingdom",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "India",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Spain",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Israel",
                  "value": 22,
                  "percent": "4"
                },
                {
                  "title": "France",
                  "value": 15,
                  "percent": "2"
                },
                {
                  "title": "Netherlands",
                  "value": 14,
                  "percent": "2"
                }
              ],
              "title": "All"
            },
            "asia": {
              "data": [
                {
                  "title": "Total",
                  "value": 170,
                  "percent": "28"
                },
                {
                  "title": "China",
                  "value": 107,
                  "percent": "18"
                },
                {
                  "title": "India",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Japan",
                  "value": 8,
                  "percent": "1"
                },
                {
                  "title": "Thailand",
                  "value": 6,
                  "percent": "1"
                },
                {
                  "title": "Kazakhstan",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Turkey",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Taiwan",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "United arab emirates",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Azerbaijan",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "South Korea",
                  "value": 2,
                  "percent": "0"
                }
              ],
              "title": "Asia"
            },
            "data": null,
            "europe": {
              "data": [
                {
                  "title": "Total",
                  "value": 184,
                  "percent": "30"
                },
                {
                  "title": "Germany",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "United Kingdom",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "Spain",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "France",
                  "value": 15,
                  "percent": "2"
                },
                {
                  "title": "Netherlands",
                  "value": 14,
                  "percent": "2"
                },
                {
                  "title": "Austria",
                  "value": 11,
                  "percent": "2"
                },
                {
                  "title": "Poland",
                  "value": 11,
                  "percent": "2"
                },
                {
                  "title": "Italy",
                  "value": 9,
                  "percent": "1"
                },
                {
                  "title": "Switzerland",
                  "value": 9,
                  "percent": "1"
                },
                {
                  "title": "Ukraine",
                  "value": 7,
                  "percent": "1"
                }
              ],
              "title": "Europe"
            },
            "isMainGraph": true,
            "northAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 85,
                  "percent": "14"
                },
                {
                  "title": "USA",
                  "value": 79,
                  "percent": "13"
                },
                {
                  "title": "Canada",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Mexico",
                  "value": 3,
                  "percent": "0"
                }
              ],
              "title": "North America"
            },
            "southAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 132,
                  "percent": "22"
                },
                {
                  "title": "Brazil",
                  "value": 119,
                  "percent": "20"
                },
                {
                  "title": "Colombia",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Argentina",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Guyana",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Paraguay",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Peru",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Uruguay",
                  "value": 1,
                  "percent": "0"
                }
              ],
              "title": "South America"
            },
            "restOfTheWorld": {
              "data": [
                {
                  "title": "Total",
                  "value": 35,
                  "percent": "6"
                },
                {
                  "title": "Israel",
                  "value": 22,
                  "percent": "4"
                },
                {
                  "title": "Australia",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Kenya",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "Morocco",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "Ivory Coast",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Libya",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Pap. New Guinea",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "South Africa",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Tunisia",
                  "value": 1,
                  "percent": "0"
                }
              ],
              "title": "Rest of the world"
            }
          },
          "title": ""
        }
      ],
      "ytd": [
        {
          "graph": {
            "all": {
              "data": [
                {
                  "title": "Total",
                  "value": 4538,
                  "percent": null
                },
                {
                  "title": "Brazil",
                  "value": 846,
                  "percent": "19"
                },
                {
                  "title": "USA",
                  "value": 749,
                  "percent": "17"
                },
                {
                  "title": "China",
                  "value": 585,
                  "percent": "13"
                },
                {
                  "title": "United Kingdom",
                  "value": 293,
                  "percent": "6"
                },
                {
                  "title": "Germany",
                  "value": 224,
                  "percent": "5"
                },
                {
                  "title": "Spain",
                  "value": 214,
                  "percent": "5"
                },
                {
                  "title": "Israel",
                  "value": 158,
                  "percent": "3"
                },
                {
                  "title": "India",
                  "value": 149,
                  "percent": "3"
                },
                {
                  "title": "France",
                  "value": 142,
                  "percent": "3"
                },
                {
                  "title": "Netherlands",
                  "value": 111,
                  "percent": "2"
                }
              ],
              "title": "All"
            },
            "asia": {
              "data": [
                {
                  "title": "Total",
                  "value": 1024,
                  "percent": "23"
                },
                {
                  "title": "China",
                  "value": 585,
                  "percent": "13"
                },
                {
                  "title": "India",
                  "value": 149,
                  "percent": "3"
                },
                {
                  "title": "Turkey",
                  "value": 62,
                  "percent": "1"
                },
                {
                  "title": "South Korea",
                  "value": 44,
                  "percent": "1"
                },
                {
                  "title": "Japan",
                  "value": 41,
                  "percent": "1"
                },
                {
                  "title": "United arab emirates",
                  "value": 34,
                  "percent": "1"
                },
                {
                  "title": "Thailand",
                  "value": 30,
                  "percent": "1"
                },
                {
                  "title": "Hong Kong",
                  "value": 19,
                  "percent": "0"
                },
                {
                  "title": "Taiwan",
                  "value": 18,
                  "percent": "0"
                },
                {
                  "title": "Kazakhstan",
                  "value": 6,
                  "percent": "0"
                }
              ],
              "title": "Asia"
            },
            "data": null,
            "europe": {
              "data": [
                {
                  "title": "Total",
                  "value": 1508,
                  "percent": "33"
                },
                {
                  "title": "United Kingdom",
                  "value": 293,
                  "percent": "6"
                },
                {
                  "title": "Germany",
                  "value": 224,
                  "percent": "5"
                },
                {
                  "title": "Spain",
                  "value": 214,
                  "percent": "5"
                },
                {
                  "title": "France",
                  "value": 142,
                  "percent": "3"
                },
                {
                  "title": "Netherlands",
                  "value": 111,
                  "percent": "2"
                },
                {
                  "title": "Italy",
                  "value": 100,
                  "percent": "2"
                },
                {
                  "title": "Austria",
                  "value": 82,
                  "percent": "2"
                },
                {
                  "title": "Switzerland",
                  "value": 65,
                  "percent": "1"
                },
                {
                  "title": "Poland",
                  "value": 57,
                  "percent": "1"
                },
                {
                  "title": "Norway",
                  "value": 29,
                  "percent": "1"
                }
              ],
              "title": "Europe"
            },
            "isMainGraph": true,
            "northAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 799,
                  "percent": "18"
                },
                {
                  "title": "USA",
                  "value": 749,
                  "percent": "17"
                },
                {
                  "title": "Mexico",
                  "value": 29,
                  "percent": "1"
                },
                {
                  "title": "Canada",
                  "value": 22,
                  "percent": "0"
                }
              ],
              "title": "North America"
            },
            "southAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 941,
                  "percent": "21"
                },
                {
                  "title": "Brazil",
                  "value": 846,
                  "percent": "19"
                },
                {
                  "title": "Uruguay",
                  "value": 43,
                  "percent": "1"
                },
                {
                  "title": "Argentina",
                  "value": 16,
                  "percent": "0"
                },
                {
                  "title": "Colombia",
                  "value": 9,
                  "percent": "0"
                },
                {
                  "title": "Honduras",
                  "value": 4,
                  "percent": "0"
                },
                {
                  "title": "Paraguay",
                  "value": 4,
                  "percent": "0"
                },
                {
                  "title": "Chile",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Peru",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Bolivia",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "Trinidad,Tobago",
                  "value": 2,
                  "percent": "0"
                }
              ],
              "title": "South America"
            },
            "restOfTheWorld": {
              "data": [
                {
                  "title": "Total",
                  "value": 266,
                  "percent": "6"
                },
                {
                  "title": "Israel",
                  "value": 158,
                  "percent": "3"
                },
                {
                  "title": "Australia",
                  "value": 38,
                  "percent": "1"
                },
                {
                  "title": "South Africa",
                  "value": 14,
                  "percent": "0"
                },
                {
                  "title": "Morocco",
                  "value": 13,
                  "percent": "0"
                },
                {
                  "title": "Ivory Coast",
                  "value": 6,
                  "percent": "0"
                },
                {
                  "title": "Algeria",
                  "value": 5,
                  "percent": "0"
                },
                {
                  "title": "Ghana",
                  "value": 5,
                  "percent": "0"
                },
                {
                  "title": "Kenya",
                  "value": 4,
                  "percent": "0"
                },
                {
                  "title": "Congo",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Pap. New Guinea",
                  "value": 3,
                  "percent": "0"
                }
              ],
              "title": "Rest of the world"
            }
          },
          "title": ""
        }
      ],
      "month": [
        {
          "graph": {
            "all": {
              "data": [
                {
                  "title": "Total",
                  "value": 606,
                  "percent": null
                },
                {
                  "title": "Brazil",
                  "value": 119,
                  "percent": "20"
                },
                {
                  "title": "China",
                  "value": 107,
                  "percent": "18"
                },
                {
                  "title": "USA",
                  "value": 79,
                  "percent": "13"
                },
                {
                  "title": "Germany",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "United Kingdom",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "India",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Spain",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Israel",
                  "value": 22,
                  "percent": "4"
                },
                {
                  "title": "France",
                  "value": 15,
                  "percent": "2"
                },
                {
                  "title": "Netherlands",
                  "value": 14,
                  "percent": "2"
                }
              ],
              "title": "All"
            },
            "asia": {
              "data": [
                {
                  "title": "Total",
                  "value": 170,
                  "percent": "28"
                },
                {
                  "title": "China",
                  "value": 107,
                  "percent": "18"
                },
                {
                  "title": "India",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "Japan",
                  "value": 8,
                  "percent": "1"
                },
                {
                  "title": "Thailand",
                  "value": 6,
                  "percent": "1"
                },
                {
                  "title": "Kazakhstan",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Turkey",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Taiwan",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "United arab emirates",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Azerbaijan",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "South Korea",
                  "value": 2,
                  "percent": "0"
                }
              ],
              "title": "Asia"
            },
            "data": null,
            "europe": {
              "data": [
                {
                  "title": "Total",
                  "value": 184,
                  "percent": "30"
                },
                {
                  "title": "Germany",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "United Kingdom",
                  "value": 27,
                  "percent": "4"
                },
                {
                  "title": "Spain",
                  "value": 23,
                  "percent": "4"
                },
                {
                  "title": "France",
                  "value": 15,
                  "percent": "2"
                },
                {
                  "title": "Netherlands",
                  "value": 14,
                  "percent": "2"
                },
                {
                  "title": "Austria",
                  "value": 11,
                  "percent": "2"
                },
                {
                  "title": "Poland",
                  "value": 11,
                  "percent": "2"
                },
                {
                  "title": "Italy",
                  "value": 9,
                  "percent": "1"
                },
                {
                  "title": "Switzerland",
                  "value": 9,
                  "percent": "1"
                },
                {
                  "title": "Ukraine",
                  "value": 7,
                  "percent": "1"
                }
              ],
              "title": "Europe"
            },
            "isMainGraph": true,
            "northAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 85,
                  "percent": "14"
                },
                {
                  "title": "USA",
                  "value": 79,
                  "percent": "13"
                },
                {
                  "title": "Canada",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Mexico",
                  "value": 3,
                  "percent": "0"
                }
              ],
              "title": "North America"
            },
            "southAmerica": {
              "data": [
                {
                  "title": "Total",
                  "value": 132,
                  "percent": "22"
                },
                {
                  "title": "Brazil",
                  "value": 119,
                  "percent": "20"
                },
                {
                  "title": "Colombia",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Argentina",
                  "value": 3,
                  "percent": "0"
                },
                {
                  "title": "Guyana",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Paraguay",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Peru",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Uruguay",
                  "value": 1,
                  "percent": "0"
                }
              ],
              "title": "South America"
            },
            "restOfTheWorld": {
              "data": [
                {
                  "title": "Total",
                  "value": 35,
                  "percent": "6"
                },
                {
                  "title": "Israel",
                  "value": 22,
                  "percent": "4"
                },
                {
                  "title": "Australia",
                  "value": 4,
                  "percent": "1"
                },
                {
                  "title": "Kenya",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "Morocco",
                  "value": 2,
                  "percent": "0"
                },
                {
                  "title": "Ivory Coast",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Libya",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Pap. New Guinea",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "South Africa",
                  "value": 1,
                  "percent": "0"
                },
                {
                  "title": "Tunisia",
                  "value": 1,
                  "percent": "0"
                }
              ],
              "title": "Rest of the world"
            }
          },
          "title": ""
        }
      ]
    },
    "type": "GraphNavigation"
  }
}

export const ICLGraphsMock = [
    salesICLMock,
    oiICLMock,
    ebitdaICLMock,
    sbuICLMock,
    commoditiesSpecialtiesMock,
    updatedTopTenProductsMock,
    topTenCustomersMock,
    territoryICLMock,
    potashAvgPriceMock,
    potashPrices,
    financialKpiGraphMock,
    FcfGraphMock,
    ICLFcfGraphMock,
    productionKmtMock,
    niICLMock,
    epsICLMock,
    capexMock
];
